import {Component, OnDestroy, inject} from '@angular/core';
import {OrdersInfo} from "../../../interfaces/orders-history";
import {OrderProductsWars, ShowTrackStatus, Transfer} from "../../../interfaces/show-track-status";
import {takeUntil} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {BaseService} from "../../../services/base.service";
import {Subject} from "rxjs";

@Component({
  selector: 'app-modal-track-status',
  templateUrl: './modal-track-status.component.html',
  styleUrls: ['./modal-track-status.component.scss']
})
export class ModalTrackStatusComponent extends BaseService implements OnDestroy {
  private http: HttpClient = inject(HttpClient);

  isDestroyed: Subject<boolean> = new Subject<boolean>();
  isTrackStatusModalShow: boolean = false;
  isDarkBackground: boolean = false;
  trackStatusOrder: OrdersInfo;
  trackStatusOrderProductsWars: OrderProductsWars[];
  trackStatusTransfer: Transfer[];
  trackStatusContactsDrivers;

  modalTrackStatusShow(order: OrdersInfo) {
    this.trackStatusOrder = order;

    this.http.post(this.apiRoot + 'orders_history/show_track_status', {
      order_id: order.order_id
    })
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: ShowTrackStatus) => {
        this.trackStatusOrderProductsWars = data.order_products_wars;
        this.trackStatusTransfer = data.transfer;
        this.trackStatusContactsDrivers = data.contacts_drivers;

        this.isTrackStatusModalShow = true;
        this.isDarkBackground = true;
      });
  }

  closeModal() {
    this.isTrackStatusModalShow = false;
    this.isDarkBackground = false;
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
